import Vue from 'vue'

// 常量：全局 toast 默认展示时长
const DEFAULT_TOAST_DURATION = 1800

const toastState = Vue.observable({
  visible: false,
  message: ''
})

let toastTimer = null

// 方法：清理 toast 定时器，避免多次提示互相覆盖
function clearToastTimer() {
  if (toastTimer) {
    window.clearTimeout(toastTimer)
    toastTimer = null
  }
}

const toast = {
  state: toastState,
  // 方法：展示全局轻量提示
  show(message, duration = DEFAULT_TOAST_DURATION) {
    clearToastTimer()
    toastState.message = message || ''
    toastState.visible = Boolean(toastState.message)

    // 逻辑分支：空文案只负责关闭提示，不启动隐藏计时
    if (!toastState.visible) {
      return
    }

    toastTimer = window.setTimeout(() => {
      toastState.visible = false
      toastState.message = ''
      toastTimer = null
    }, duration)
  },
  // 方法：手动关闭全局轻量提示
  clear() {
    clearToastTimer()
    toastState.visible = false
    toastState.message = ''
  }
}

export default toast
